import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// The browser's default history.scrollRestoration ('auto') restores the
// pre-refresh scroll offset on reload, racing any in-app "scroll to top"
// logic (e.g. dashboard-new.component.ts's resetScrollPosition) — whichever
// runs later wins, so pages can still land mid-scroll after a hard refresh.
// Disabling it here, before the app bootstraps, makes every reload start at
// the top and leaves scroll position fully under app control.
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
